export function isCrmViewOnlyUser(
	user?: { role?: string; isLeadAgency?: boolean } | null
): boolean {
	if (!user?.role) return false;
	if (user.role === "EXTERNAL_PARTNER") return true;
	return user.role === "SALES_PERSON" && !!user.isLeadAgency;
}

export function shouldMaskLeadPhone(user?: { role?: string } | null): boolean {
	return user?.role === "EXTERNAL_PARTNER";
}

export function isExternalPartner(user?: { role?: string } | null): boolean {
	return user?.role === "EXTERNAL_PARTNER";
}

/** Super admin or chain hospital admin — delete lead / edit campaign name. */
export function canElevatedLeadAdmin(
	user?: { role?: string; adminScope?: string } | null
): boolean {
	if (!user?.role) return false;
	if (user.role === "SUPER_ADMIN") return true;
	return user.role === "HOSPITAL_ADMIN" && user.adminScope === "CHAIN";
}

/** Hospital admin or super admin — permanently delete CRM app call recordings. */
export function canDeleteLeadCallRecording(user?: { role?: string } | null): boolean {
	if (!user?.role) return false;
	return user.role === "SUPER_ADMIN" || user.role === "HOSPITAL_ADMIN";
}

